import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AssessmentTemplate from 'pages/AssessmentDetails/AssessmentTemplate';
import AssessmentQuestions from 'pages/AssessmentDetails/AssessmentQuestions';
import PerformanceEvaluation from 'pages/Performance Evaluation/performanceEvaluation';
import BatchStudentsMarks from 'pages/Performance Evaluation/BatchStudentsMarks';
import StudentMarksEntry from 'pages/Performance Evaluation/StudentMarksEntry';
import ResultDetails from 'pages/Result/ResultDetails';
import StudentResultDetail from 'pages/Result/StudentResultDetail';
const DashboardHome = Loadable(lazy(() => import('pages/dashboard')));
const QuestionBankList = Loadable(lazy(() => import('pages/QuestionBank/QuestionBankList')));
const AddOrEditQuestion = Loadable(lazy(() => import('pages/QuestionBank/AddQuestion')));
const RubricsList = Loadable(lazy(() => import('../pages/rubrics/RubricsList')));
const AddRubrics = Loadable(lazy(() => import('pages/rubrics')));
const AssessorsList = Loadable(lazy(() => import('pages/assessors/AssessorsList')));
const AddAssessor = Loadable(lazy(() => import('pages/assessors/AddAssessor')));
const AssessorAdminGuard = Loadable(lazy(() => import('utils/route-guard/AssessorAdminGuard')));
const NcvetQuestionBankAccessGuard = Loadable(lazy(() => import('utils/route-guard/NcvetQuestionBankAccessGuard')));
const BatchesList = Loadable(lazy(() => import('pages/batches/BatchesList')));
const BatchAssignAssessors = Loadable(lazy(() => import('pages/batches/BatchAssignAssessors')));
const AgencyLibrarySettingsPage = Loadable(lazy(() => import('pages/agency-library/AgencyLibrarySettingsPage')));
const NotificationsPage = Loadable(lazy(() => import('pages/notifications/NotificationsPage')));
const TicketsPage = Loadable(lazy(() => import('pages/tickets/TicketsPage')));
const AddTicket = Loadable(lazy(() => import('pages/tickets/AddTicket')));

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    { path: 'dashboard', element: <DashboardHome /> },
    {
      path: 'notifications',
      children: [{ index: true, element: <NotificationsPage /> }]
    },
    {
      path: 'rubrics',
      element: <NcvetQuestionBankAccessGuard />,
      children: [
        { index: true, element: <RubricsList /> },
        { path: 'add', element: <AddRubrics /> },
        { path: 'edit', element: <AddRubrics /> }
      ]
    },
    {
      path: 'assessors',
      element: <AssessorAdminGuard />,
      children: [
        { index: true, element: <AssessorsList /> },
        { path: 'add', element: <AddAssessor /> },
        { path: 'edit', element: <AddAssessor /> }
      ]
    },
    {
      path: 'batches',
      element: <AssessorAdminGuard />,
      children: [
        { index: true, element: <BatchesList /> },
        { path: 'assign', element: <BatchAssignAssessors /> }
      ]
    },
    {
      path: 'agency-library-settings',
      element: <AssessorAdminGuard />,
      children: [{ index: true, element: <AgencyLibrarySettingsPage /> }]
    },
    {
      path: 'assessment-details',
      children: [
        { index: true, element: <AssessmentTemplate /> },
        {
          path: 'questions',
          element: <NcvetQuestionBankAccessGuard />,
          children: [{ index: true, element: <AssessmentQuestions /> }]
        }
      ]
    },
    {
      path: 'question-bank',
      element: <NcvetQuestionBankAccessGuard />,
      children: [
        { index: true, element: <QuestionBankList /> },
        { path: 'add', element: <AddOrEditQuestion /> },
        { path: 'edit', element: <AddOrEditQuestion /> }
      ]
    },
    {
      path:'performance-evaluation',
      children: [
        { index: true, element: <PerformanceEvaluation /> },
        { path: 'batch-students-marks', element: <BatchStudentsMarks /> },
        { path: 'student-marks-entry', element: <StudentMarksEntry /> }
      ]
    },
    {
      path: 'result',
      children: [
        { index: true, element: <ResultDetails /> },
        { path: 'student', element: <StudentResultDetail /> }
      ]
    },
    {
      path: 'tickets',
      children: [
        { index: true, element: <TicketsPage /> },
        { path: 'add', element: <AddTicket /> },
        { path: 'edit/:id', element: <AddTicket /> }
      ]
    }
  ]
};

export default MainRoutes;
